import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["user", "value", "selected", "className", "onSelect"];
import { CommandItem } from "../../_shadcn-native-components/command";
import { cn } from "../../utils";
import { sanitizeText } from "../utils/sanitize-text";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var DropdownUserItem = function DropdownUserItem(_ref) {
  var user = _ref.user,
    value = _ref.value,
    selected = _ref.selected,
    className = _ref.className,
    _onSelect = _ref.onSelect,
    itemProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(CommandItem, _objectSpread(_objectSpread({
    value: value,
    searchKey: user.name,
    selected: selected,
    onSelect: function onSelect() {
      return _onSelect(value);
    },
    className: cn('tw-h-5.6 tw-py-0.8', selected && 'tw-bg-neutral-light-300 dark:tw-bg-neutral-dark-600', className)
  }, itemProps), {}, {
    children: /*#__PURE__*/_jsxs("div", {
      className: "tw-flex tw-items-center tw-gap-0.8",
      children: [/*#__PURE__*/_jsx("img", {
        src: user.avatar,
        alt: user.name,
        className: "tw-h-3.2 tw-w-3.2 tw-rounded-full"
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-flex tw-flex-col tw-justify-between tw-h-4",
        children: [/*#__PURE__*/_jsx("div", {
          className: "tw-font-subtitle5 tw-line-clamp-1",
          children: sanitizeText(user.name)
        }), /*#__PURE__*/_jsx("div", {
          className: "tw-font-body5 tw-line-clamp-1 tw-text-neutral-light-700 dark:tw-text-neutral-dark-300",
          children: sanitizeText(user.position)
        })]
      })]
    })
  }));
};